import Component from '../core/Component';

export default class PlatformSearch extends Component {
    hideClass = 'd-none';

    constructor(element) {
        super(element);

        this.ref = {
            searchInput:       null,
            searchInputEraser: null,
            searchSuggestions: null
        };
    }

    prepare() {
        this.ref.searchInput.value.length > 0 ? this.eraserShow(true) : null;
        this.ref.searchInput.addEventListener('keyup', this.onKeyUp.bind(this));
        this.ref.searchInput.addEventListener("keydown", (event) => this.keyEvents(event.keyCode));
        this.ref.searchInput.addEventListener("blur", () => this.hideSuggestions());
        // this.ref.searchInput.addEventListener("blur", this.inputBlur.bind(this));
        this.ref.searchInputEraser.addEventListener('click', this.clearSearchInput.bind(this));
    }

    keyEvents(keyCode) {
        switch (keyCode) {
            case 27:
                this.ref.searchInput.blur();
                break;
            // del
            case 46:
                this.clearSearchInput();
                break;
        }
    }

    onKeyUp() {
        if (this.ref.searchInput.value.length > 0) {
            this.eraserShow(true);

            if (this.ref.searchSuggestions) {
                this.showSuggestions();
                this.searchSuggestPlatforms();
            } else {
                this.searchPlatforms();
            }
        } else {
            this.eraserShow(false);
            this.showAllSearchable();
            this.hideSuggestions();
        }
    }

    showSuggestions() {
        if (!this.ref.searchSuggestions) {
            return;
        }

        let elClassList = this.ref.searchSuggestions.classList;

        if (!elClassList.contains('show')) {
            elClassList.add('show');
        }
    }

    hideSuggestions() {
        if (!this.ref.searchSuggestions) {
            return;
        }

        let elClassList = this.ref.searchSuggestions.classList;

        setTimeout(function () {
            if (elClassList.contains('show')) {
                elClassList.remove('show');
            }
        }, 300);
    }

    searchSuggestPlatforms() {
        let searchValue = this.ref.searchInput.value;
        let suggestions = document.getElementsByClassName('suggestions__item');
        let self = this;

        Array.from(suggestions).forEach((suggestion) => self.searchInElement(suggestion, searchValue));
    }

    searchPlatforms() {
        let searchValue = this.ref.searchInput.value;
        let searchable = document.querySelectorAll('[data-searchable]');
        let self = this;

        searchable.forEach(function (elem) {
            self.searchInElement(elem, searchValue);
        });
    }

    searchInElement(element, searchValue) {
        let nameEl = element.getElementsByClassName('js-platform-name');
        let name = nameEl[0].innerText.toLowerCase();

        element.classList.add(this.hideClass);

        if (name.indexOf(searchValue) !== -1) {
            element.classList.remove(this.hideClass);
        }
    }

    showAllSearchable() {
        let searchable = document.querySelectorAll('[data-searchable]');
        let self = this;

        searchable.forEach(function (elem) {
            elem.classList.remove(self.hideClass);
        });
    }

    clearSearchInput() {
        this.ref.searchInput.value = '';
        this.ref.searchInput.focus();
        this.eraserShow(false);
        this.showAllSearchable();
        this.hideSuggestions();
    }

    eraserShow(state) {
        if (state) {
            this.ref.searchInputEraser.classList.add('visible');
        } else {
            this.ref.searchInputEraser.classList.remove('visible');
        }
    }
}
